export default __webpack_public_path__ + "static/media/banescale.2a09a61b.png";